import { Tabs, Tab } from "@podtrac/common/tabs";
import { css } from "@emotion/react";
import { Helmet } from "react-helmet";
import { NavLink, Outlet } from "react-router-dom";
import { DownloadsLabel } from "../shared/DownloadsLabel";
import PaidFeatureButton from "../shared/PaidFeatureButton";
import { useAccount } from "../store/account";

export default function Downloads() {
    const { data: account } = useAccount();
    return (
        <>
            <Helmet>
                <title>{DownloadsLabel() + " - Podtrac"}</title>
            </Helmet>
            <div>
                <Tabs>
                    <Tab>
                        <NavLink to="episode">Episode</NavLink>
                    </Tab>
                    {account && (account.isPaidPlan || account.offerUpgrade) ? (
                        <Tab>
                            <PaidFeatureButton
                                hasFeature={account.isPaidPlan}
                                dialogContent="The Episode Comparison report is a premium feature available in the Grow Your Show Plan."
                            >
                                {({ hasFeature, openModal }) => (
                                    <NavLink
                                        onClick={
                                            hasFeature ? () => {} : openModal
                                        }
                                        to="compare-episodes"
                                    >
                                        Compare Episodes
                                    </NavLink>
                                )}
                            </PaidFeatureButton>
                        </Tab>
                    ) : null}
                    <Tab>
                        <NavLink to="country">Country</NavLink>
                    </Tab>
                    <Tab>
                        <NavLink to="client">Client</NavLink>
                    </Tab>
                </Tabs>
                <Outlet />
            </div>
        </>
    );
}
